export const goHome = (): void => {
  window.location.hash = '#/';
};

export const goToEditor = (id: string): void => {
  window.location.hash = `#/edit/${encodeURIComponent(id)}`;
};

export const currentProjectId = (): string | null => {
  const match = window.location.hash.match(/^#\/edit\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};
